<template>
    <Navbar v-if="isSignedIn && !['TreatmentPlan', 'TicketResolveOTP', 'TicketImages'].includes(this.$route.name)" />
    <div v-if="isSignedIn && !['Practices', 'TreatmentPlan', 'TicketResolveOTP', 'TicketImages'].includes(this.$route.name)" class="d-flex flex-grow-1">
        <div class="container-xxl d-flex flex-column flex-grow-1">
            <div class="row flex-grow-1">
                <div class="col-lg-3 col-xxl-2 d-none d-lg-block nav-column">
                    <div class="py-4 pe-3">
                        <Nav />
                    </div>
                </div>
                <div class="col-lg-9 col-xxl-10 col-12 content-column">
                    <div class="py-4 px-2 px-lg-3">
                        <router-view />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="isSignedIn && ['Practices'].includes(this.$route.name)" class="d-flex flex-grow-1">
        <div class="container-xxl">
            <div class="py-4 px-2">
                <router-view />
            </div>
        </div>
    </div>
    <div v-if="isSignedIn && ['TreatmentPlan', 'TicketResolveOTP', 'TicketImages'].includes(this.$route.name)" style="height:100vh">
        <router-view />
    </div>
    <router-view class="px-4" v-if="!isSignedIn" />
    <PracticeSwitchedModal v-if="isSignedIn" />
</template>

<script>
    import Navbar from '@/components/Navbar.vue';
    import Nav from '@/components/Nav.vue';
    import PracticeSwitchedModal from '@/components/PracticeSwitchedModal.vue';

    export default {
        components: {
            Navbar,
            Nav,
            PracticeSwitchedModal,
        },
        computed: {
            isSignedIn () {
                return this.$store.state.isSignedIn;
            },
            user () {
                return this.$store.state.user
            },
        },
    }
</script>

<style scoped lang="scss">
    .nav-column
    {
        border-right: 3px solid $swift-lighter-grey;
    }
    .content-column
    {
        padding-bottom: 80px;
    }
</style>

<style lang="scss">
    body
    {
        min-height: 100vh;
    }

    #app
    {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }
    .input-group .input-group-text {
        background:linear-gradient(0deg, $swift-fresh-green, rgb(222 255 212));
        border-radius: 0.375rem 0 0 0.375rem;
    }
</style>